import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { SourceBlock } from './SourceBlock';
import { ExcelSheetsBlock } from './ExcelSheetsBlock';
import { SupplyClass } from './supplyClassesData';
import { CsvExportBlock } from './CsvExportBlock';
interface SupplyClassSectionProps {
  supplyClass: SupplyClass;
}
export const SupplyClassSection = ({
  supplyClass
}: SupplyClassSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  // Filter sources based on supply class
  const filteredSources = supplyClass.sources.filter(source => {
    // For Class I (Rations), don't show GCSS-A and JBCP sources
    if (supplyClass.id === 'class-i') {
      return source.type !== 'gcss-a' && source.type !== 'jbcp';
    }
    // For all other classes, show all sources
    return true;
  });
  // Define CSV files for different source types
  const csvFiles = {
    'class-vii': {
      gcss: [{
        fileName: 'equipment_status_report.csv'
      }, {
        fileName: 'major_items_inventory.csv'
      }, {
        fileName: 'fmc_status_report.csv'
      }],
      jbcp: [{
        fileName: 'jbcp_equipment_status.csv'
      }, {
        fileName: 'jbcp_equipment_location.csv'
      }]
    },
    'class-ix': {
      gcss: [{
        fileName: 'vehicle_parts_inventory.csv'
      }, {
        fileName: 'parts_requisition_status.csv'
      }, {
        fileName: 'maintenance_parts_usage.csv'
      }, {
        fileName: 'vehicle_service_history.csv'
      }],
      jbcp: [{
        fileName: 'jbcp_depot_parts_inventory_daily.csv'
      }, {
        fileName: 'jbcp_vehicle_repair_status_by_site.csv'
      }, {
        fileName: 'jbcp_location_parts_requisitions_daily.csv'
      }]
    }
  };
  // Get description based on class
  const getDescription = (system: string, classId: string) => {
    if (system === 'gcss') {
      return `Data from GCSS-Army for ${classId === 'class-vii' ? 'Class VII Major Items tracking and status reporting' : 'Class IX Vehicle Repair Parts tracking and inventory management'}`;
    } else {
      return `Data from Joint Battle Command Platform for ${classId === 'class-vii' ? 'Class VII Major Items tracking' : 'Class IX Vehicle Repair Parts tracking and requisition status'}`;
    }
  };
  return <div className="border border-gray-200 rounded-lg shadow-sm" data-id="element-71">
      <div className="flex items-center justify-between p-3 cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} data-id="element-72">
        <div className="flex items-center" data-id="element-73">
          <span className="mr-2 text-xl" data-id="element-74">{supplyClass.icon}</span>
          <h3 className="text-base font-semibold text-gray-900" data-id="element-75">
            Class {supplyClass.romanNumeral} — {supplyClass.name}
          </h3>
        </div>
        <button className="text-gray-500 hover:text-gray-700" data-id="element-76">
          {isExpanded ? <ChevronUpIcon size={18} data-id="element-77" /> : <ChevronDownIcon size={18} data-id="element-78" />}
        </button>
      </div>
      {isExpanded && <div className="px-3 pb-3" data-id="element-79">
          {/* For Major Items (Class VII) or Repair Parts (Class IX), show special sections */}
          {supplyClass.id === 'class-vii' || supplyClass.id === 'class-ix' ? <>
              {/* Other data sources */}
              {filteredSources.some(source => source.type !== 'excel' && source.type !== 'gcss-a' && source.type !== 'jbcp') && <div className="mb-3" data-id="element-80">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-81">
                    {filteredSources.map(source => source.type !== 'excel' && source.type !== 'gcss-a' && source.type !== 'jbcp' ? <SourceBlock key={source.id} source={source} data-id="element-82" /> : null)}
                  </div>
                </div>}
              {/* GCSS-A Section */}
              {filteredSources.some(source => source.type === 'gcss-a') && <CsvExportBlock title="GCSS-A Daily CSV Exports" color="blue" badge={supplyClass.id === 'class-vii' ? 'Major Items' : 'Repair Parts'} files={csvFiles[supplyClass.id]?.gcss || []} description={getDescription('gcss', supplyClass.id)} data-id="element-83" />}
              {/* JBCP Section */}
              {filteredSources.some(source => source.type === 'jbcp') && <CsvExportBlock title="JBCP Daily CSV Exports" color="purple" badge={supplyClass.id === 'class-vii' ? 'Major Items' : 'Repair Parts'} files={csvFiles[supplyClass.id]?.jbcp || []} description={getDescription('jbcp', supplyClass.id)} data-id="element-84" />}
              {/* Excel Sheets Section */}
              {supplyClass.sources.some(source => source.type === 'excel') && <ExcelSheetsBlock excelSource={supplyClass.sources.find(source => source.type === 'excel')} data-id="element-85" />}
            </> : <>
              {/* Default view for other supply classes */}
              {filteredSources.some(source => source.type !== 'excel') && <div className="mb-3" data-id="element-86">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-87">
                    {filteredSources.map(source => source.type !== 'excel' ? <SourceBlock key={source.id} source={source} data-id="element-88" /> : null)}
                  </div>
                </div>}
              {supplyClass.sources.some(source => source.type === 'excel') && <ExcelSheetsBlock excelSource={supplyClass.sources.find(source => source.type === 'excel')} data-id="element-89" />}
            </>}
        </div>}
    </div>;
};